export const CompanyAttribute = {
    DEPARTMENTS: 'Departments',
    EMPLOYEE_LEVELS: 'EmployeeLevels',
    JOB_TITLES: 'JobTitles',
    COMPANY_ADDRESSES: 'CompanyAddresses',
    MANAGERS: 'Managers',
    CUSTOM_ATTRIBUTES: 'CustomAttributes',
    AGE_GROUPS: 'ageGroups',
    TENURES: 'tenures',
} as const;

export type CompanyAttributeKey = keyof typeof CompanyAttribute;
